module.exports = __webpack_public_path__ + "img/zhuyuanshoushu.c39d73ac.png";